import React, { useState, useEffect } from "react";
import styles from "../checkout.module.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { checkOutAction } from "../../../redux/action";
import { isCardEmtpy } from "../../../constant/utils";
interface IBooking {
  bookingData: any;
  setBookingData: (val: any) => void;
}

const Schedual = ({ bookingData, setBookingData }: IBooking) => {
  const dispatch = useDispatch();
  const [date, setDate] = useState<any[]>([]);
  const slotData: any = useSelector((state: any) => (state.checkout.slot ? state.checkout.slot : []));
  const bookingValidation: any = useSelector((state: any) =>
    state.checkout.bookingValidation ? state.checkout.bookingValidation : {}
  );

  function slotDisable(time: any) {
    time = time?.split("to");
    time = time[1]?.trim()?.replace(".", ":");
    time = moment(time, "hh:mm A")
      .subtract({ hour: bookingValidation?.priorHoursCapping || 0 })
      ?.format("HH");
    if (moment().format("YYYY-MM-DD") != bookingData?.ScheduleDate) {
      return false;
    } else {
      if (Number(bookingValidation?.currentHours) > Number(time)) {
        return true;
      } else {
        return false;
      }
    }
  }

  useEffect(() => {
    let boxingDay: any = new Date();
    let nextWeek = boxingDay * 1 + 2 * 6 * 24 * 3600 * 1000;
    function getDates(d1: any, d2: any) {
      var oneDay = 24 * 3600 * 1000;
      for (var d = [], ms = d1 * 1, last = d2 * 1; ms < last; ms += oneDay) {
        let dt: any = moment(new Date(ms)).format("YYYY-MM-DD");
        d.push(dt);
      }
      return d;
    }
    let data = getDates(boxingDay, nextWeek);
    setDate(data);
    return () => {};
  }, []);

  const handleSelectDate = (e: any) => {
    if (!isCardEmtpy()) {
      setBookingData({
        ...bookingData,
        ScheduleDate: e.target.value,
        ScheduleTime: "",
      });
      dispatch(
        checkOutAction.bookingValidationAction({
          PreferredDate: e.target.value,
          PreferredTime: "",
          CityId: bookingData?.selectedAddress?.city_id,
        })
      );
      dispatch(checkOutAction.availableSlotAction({ Date: e.target.value }));
    }
  };
  const handleSelectTime = (e: any) => {
    if (!isCardEmtpy()) {
      const selectedTime = e.target.value;
      dispatch(
        checkOutAction.bookingValidationAction({
          PreferredDate: bookingData?.ScheduleDate,
          PreferredTime: selectedTime,
          CityId: bookingData?.selectedAddress?.city_id,
        })
      );
      setBookingData({
        ...bookingData,
        ScheduleTime: selectedTime,
        PaymentMode: "",
        tab: "payment",
      });
    }
  };

  return (
    <div className={styles.paddingbox}>
      <div className={styles.schedualTopHead}>Choose Preferred Date & Time Slot for Home Sample Collection *</div>
      <div className={styles.schedualSelectBox}>
        <select onChange={handleSelectDate} value={bookingData?.ScheduleDate}>
          <option>Choose Date</option>
          {date?.map((_date: any) => (
            <option value={_date}>{moment(new Date(_date)).format("DD-MM-YYYY")}</option>
          ))}
        </select>
        <select
          onChange={handleSelectTime}
          value={bookingData?.ScheduleTime}
          disabled={bookingValidation?.orderStatusInCity?.status === false}
        >
          <option>Choose Slot</option>
          {slotData?.map((_slot: any) => (
            <option value={_slot} disabled={slotDisable(_slot) || _slot == "4.00 PM to 7.00 PM" ? true : false}>
              {_slot}
              {_slot == "4.00 PM to 7.00 PM" && " (Occupied)"}
            </option>
          ))}
        </select>
      </div>
      <p className={styles.schedualFooterText}>*The operational timings may vary from center to center.</p>
    </div>
  );
};

export default Schedual;
